/* eslint semi:0 */
import { inViewport, } from 'verge'
import { isDesktop, } from 'utils/ua'
import { queryString, } from 'utils/window'
import { noop, } from 'utils/fn'
import { AD_FORMATS, } from 'config/adsConfig'
import { postTemplate, } from 'application/pageDataObject'
import { getSingleElementByClass, } from 'utils/dom'
import Actions from 'actions/brightcovePlayerActions'
import BrightcoveBasePlayerVm from './brightcoveBasePlayerVm'
import scrollingEventsProvider from 'providers/scrollingEventsProvider'
import { getCountryCode, NO_LOCATION, } from 'providers/geolocationProvider'


const { debugBcPlay, } = queryString

const AUTOPLAY_BLACKLIST_TEMPLATE_TYPES = ['slideshow', ]

// CountryCode list source: http://dev.maxmind.com/geoip/legacy/codes/iso3166/
const AUTOPLAY_ENABLED_COUNTRY_CODES_EMEA =     ['gb', 'de', 'tr', 'it', ] // 'es', 'fr', 'ie',
const AUTOPLAY_ENABLED_COUNTRY_CODES_US_LATAM = ['us', 'co', 'br', 'ar', 'mx', 'cl', 've', 'pe', ]
// const AUTOPLAY_ENABLED_COUNTRY_CODES_APAC =     ['th', 'au', 'my', 'sg', 'id', 'vn', ]

const AUTOPLAY_WHITELIST_GEOS = [
  ...AUTOPLAY_ENABLED_COUNTRY_CODES_EMEA,
  ...AUTOPLAY_ENABLED_COUNTRY_CODES_US_LATAM,
  // ...AUTOPLAY_ENABLED_COUNTRY_CODES_APAC,
]

const VIEWPORT_ACTIONS = [
  Actions.TYPES.PLAYER_ENTER_VIEWPORT,
  Actions.TYPES.PLAYER_EXIT_VIEWPORT,
]

export default class BrightcoveCoverPlayerVm extends BrightcoveBasePlayerVm {

  constructor(...args){
    super(...args)
    this.merge({
      currentCountryCode: NO_LOCATION,
    })
    getCountryCode().
      then(this.setCountryCode.bind(this)).
      catch(noop)
  }

  setCountryCode(countryCode = NO_LOCATION){
    return this.merge({
      currentCountryCode: countryCode.toLowerCase(),
    });
  }

  setupAutoplayAndScrollingBehaviour(){
    if (this.isAutoplayAllowed) {
      this.registerScrollingActions()
    }
    return this
  }

  onChange(action){
    if (this.isViewportAction(action)) {
      this.onViewportChange()
    }
    return super.onChange(action)
  }

  isViewportAction(action){
    let actionType = action && action.type
    return !!(actionType && VIEWPORT_ACTIONS.includes(actionType))
  }

  onViewportChange(){
    debugBcPlay && this.info('IN VIEWPORT', this.videoId, this)
    if (this.shouldAutoplay) {
      if (!this.alreadyAutoplayed) {
        this.alreadyAutoplayed = true
        this.initPlayback()
      }
    }
  }

  initPlayback(){
    if (this.isAutoplayAllowed) {
      this.isAutoPlaying = true
      this.play()
    }
    return this;
  }

  pause(){
    debugBcPlay && this.info('PAUSING', this.videoId, this)
    this
      .merge({
        isAutoPlaying: false,
      })
      .player.pause()
    return this
  }

  set alreadyAutoplayed(bool){ this._alreadyAutoplayed = bool }
  get alreadyAutoplayed(){ return !!this._alreadyAutoplayed }

  get isInViewport(){ return this.store.isCoverPlayerOldestInViewport(this.elementId) }

  get playerName(){ return 'cover' }

  get usersVolumes(){
    return {
      'USER_ROLES:ADMIN': 0,
      'USER_ROLES:OTHER': 0.2,
    }
  }

  get adFormat(){
    return AD_FORMATS.Vcover
  }

  play(){
    debugBcPlay && this.info('PLAYING', this.videoId, this)
    return super
      .play()
      .setCurrentVideoTitle()
  }

  setCurrentVideoTitle(){
    this.player.getCurrentVideo(currentVideo => this.merge({ currentVideo, }))
    return this
  }

  onTemplateReady(player){
    this.setupAutoplayAndScrollingBehaviour()
    this.initializeInViewportProperty()
    return super.onTemplateReady(player)
  }

  initializeInViewportProperty(){
    return this.scrollEvent(inViewport(this.rootNode))
  }

  get videoTitle(){
    let { currentVideo, } = this
    return currentVideo && currentVideo.displayName || ''
  }

  get shouldAutoplay(){
    return this.isAutoplayAllowed && this.isInViewport
  }

  get isAutoplayAllowed(){
    const isAutoplayDisabled = /* noAutoplay || false */ true
    const isAutoplayAllowed = isDesktop && this.isAutoplayAllowedForTemplate && this.isAutoplayAllowedForLocale
    return !isAutoplayDisabled && isAutoplayAllowed
  }

  get isAutoplayAllowedForLocale(){ return AUTOPLAY_WHITELIST_GEOS.includes(this.currentCountryCode) }

  get autoStart(){ return false }

  get isAutoplayAllowedForTemplate(){ return !AUTOPLAY_BLACKLIST_TEMPLATE_TYPES.includes(postTemplate) }

  get shouldApplyVolume(){ return true }

  registerScrollingActions(){
    scrollingEventsProvider.register(this.scrollingActionsConfig)
    return this
  }

  get scrollingActionsConfig(){
    return {
      element: this.rootNode,
      triggerPosition: {
        bottom: 0,
      },
      event: 'scrollEvent',
      vm: this,
      relativeTopElement: getSingleElementByClass('header-container'),
    }
  }

  scrollEvent(isInViewport){
    let action = isInViewport ? 'playerEnterViewport' : 'playerExitViewport'
    setImmediate(Actions[action].part(this.elementId))
    return this
  }

}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/vms/brightcoveCoverPlayerVm.js